import { Box, Card, Text, TextButton } from '@wix/design-system';
import { Trans, useTranslation } from '@wix/fe-essentials/react';
import { CollapseList } from '@wix/rules-panel-ui';
import { useAtomValue } from 'jotai';
import React, { useMemo } from 'react';
import { scrollerNodeRefAtom } from '../../atoms/session-atoms';
import { BiCtaNames } from '../../bi/types';
import { useBiLogger } from '../../hooks/use-bi-logger';
import { SpecificPageList } from '../wizard-content/content-results/card-groups/lists/specific-page-list';
import { SpecificPageTaskList } from '../wizard-content/content-results/card-groups/lists/specific-page-task-list';
import { useVerticalDrillInScreen } from './use-vertical-drill-in-screen';
export const VerticalsDrillInContentCards = () => {
  const {
    t
  } = useTranslation();
  const {
    itemType,
    pageId = '',
    crossPagesRuleResult,
    specificRuleGroupPaginationObject,
    shouldShowMaxPagesWarning,
    screenTitle,
    executionResults,
    isAllCrossPageIssuePassed
  } = useVerticalDrillInScreen();
  const biLogger = useBiLogger();
  const totalResults = Object.keys(executionResults).length;
  const {
    ruleGroupToShow,
    isPaginationEnabled,
    setIsPaginationEnabled,
    getPaginationComponent,
    isPagination
  } = specificRuleGroupPaginationObject;
  const scrollerNode = useAtomValue(scrollerNodeRefAtom);
  const pageIds = useMemo(() => {
    return ruleGroupToShow.map(ruleGroup => ruleGroup.groupId);
  }, [ruleGroupToShow]);
  const ruleResultsMap = useMemo(() => {
    const map = new Map();
    ruleGroupToShow.forEach(ruleGroup => {
      map.set(ruleGroup.groupId, ruleGroup.ruleResults);
    });
    return map;
  }, [ruleGroupToShow]);
  return /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    paddingLeft: "24px",
    paddingRight: "24px"
  }, /*#__PURE__*/React.createElement(Card, {
    showShadow: true
  }, /*#__PURE__*/React.createElement(Box, {
    padding: "12px 18px 15px 18px"
  }, /*#__PURE__*/React.createElement(Text, {
    size: "small",
    weight: "bold"
  }, screenTitle + ` (${totalResults})`)), /*#__PURE__*/React.createElement(Box, {
    width: "100%"
  }, /*#__PURE__*/React.createElement(CollapseList, {
    autoScroll: true,
    contentGap: 0,
    scrollContainerRef: scrollerNode ?? undefined
  }, /*#__PURE__*/React.createElement(CollapseList.SectionItem, {
    id: "cross-pages",
    key: "cross-pages",
    title: t(`accessibility-wizard.verticals-drill-in.content-section.cross-pages-rules.divider`),
    tooltipText: t(`accessibility-wizard.verticals-drill-in.content-section.cross-pages-rules.tooltip.${itemType}`)
  }), /*#__PURE__*/React.createElement(SpecificPageTaskList, {
    key: "cross-pages-tasks",
    pageId: pageId,
    ruleResults: crossPagesRuleResult
  }), /*#__PURE__*/React.createElement(CollapseList.SectionItem, {
    id: "page-specific",
    title: t('accessibility-wizard.verticals-drill-in.content-section.page-specific-rules.divider'),
    tooltipText: t(`accessibility-wizard.verticals-drill-in.content-section.page-specific-rules.tooltip.${itemType}`)
  }), /*#__PURE__*/React.createElement(SpecificPageList, {
    isAllCrossPageIssuePassed: isAllCrossPageIssuePassed,
    key: "specific-page-list",
    pageIds: pageIds,
    ruleResultsMap: ruleResultsMap
  }), isPagination && isPaginationEnabled && !shouldShowMaxPagesWarning && getPaginationComponent(), !isPaginationEnabled && /*#__PURE__*/React.createElement(Box, {
    margin: "SP2"
  }, /*#__PURE__*/React.createElement(Text, {
    size: "tiny",
    weight: "thin",
    secondary: true
  }, /*#__PURE__*/React.createElement(Trans, {
    components: {
      text: /*#__PURE__*/React.createElement(Text, {
        size: "tiny",
        weight: "thin",
        secondary: true
      }),
      textButton: /*#__PURE__*/React.createElement(TextButton, {
        as: "a",
        size: "tiny",
        skin: "dark",
        underline: "always",
        weight: "thin",
        onClick: () => {
          biLogger.ctaClick({
            ctaName: BiCtaNames.ShowAllPages
          });
          setIsPaginationEnabled(true);
        }
      })
    },
    i18nKey: `accessibility-wizard.verticals-drill-in.content-section.pagination.enable-pagination.${itemType}`
  })))))));
};
//# sourceMappingURL=verticals-drill-in-content-cards.js.map